import React from "react"
import PropTypes from "prop-types"

import { Modal, ModalOverlay, ModalContent } from ".."
import { useDisclosure } from "../../Hooks"
import { EditIcon } from "../../Icon"
import { Button, IconButton } from "../../Button"
import { Box } from "../../Box"

const ModalWithButton = ({
  button = {},
  isOpen: initialIsOpen,
  onOpen: initialOnOpen,
  onClose: initialOnClose,
  children,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure({
    isOpen: initialIsOpen,
    onOpen: initialOnOpen,
    onClose: initialOnClose,
  })
  const { text, icon, ...restButtonProps } = button

  return (
    <>
      {text ? (
        <Button onClick={onOpen} {...restButtonProps}>
          {text}
        </Button>
      ) : (
        <IconButton
          icon={icon ? icon : <EditIcon />}
          mx="1rem"
          onClick={onOpen}
          {...restButtonProps}
        />
      )}

      <Modal isOpen={isOpen} onClose={onClose} size="4xl" height="1000px">
        <ModalOverlay />
        <ModalContent py="3rem">
          <Box>{children}</Box>
        </ModalContent>
      </Modal>
    </>
  )
}

export { ModalWithButton }

ModalWithButton.propTypes = {
  button: PropTypes.object,
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
}
